import {Injectable} from '@angular/core';

import {IAdapter} from '../..';
import {CoreAuthModule} from '../auth.module';
import {LoginModel} from '../models';

@Injectable({
  providedIn: CoreAuthModule,
})
export class LoginAdapterService implements IAdapter<LoginModel> {
  adaptToModel(resp: any): any {
    return resp;
  }
  adaptFromModel(data: LoginModel): any {
    return {
      username: data.username,
      password: data.password,
      client_id: data.client_id,
      client_secret: data.client_secret,
    };
  }
}
